<template>
  <div class="recommend-goods">
    <el-form :inline="true" size="small">
      <el-form-item>
        <el-select
          v-model="searchFrom.goodsOneClassId"
          style="width: 180px"
          @change="searchHandleOne"
        >
          <el-option
            v-for="item in classListOne"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="searchFrom.goodsTwoClassId"
          style="width: 180px"
          @change="searchHandleTwo"
        >
          <el-option
            v-for="item in classListTwo"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchFrom.goodsThreeClassId" style="width: 180px">
          <el-option
            v-for="item in classListThree"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchFrom.goodsName"
          style="width: 180px"
          placeholder="药品名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="searchFrom.factory"
          style="width: 180px"
          placeholder="厂家名称"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <!-- 已选｜未选 -->
        <el-radio-group v-model="selectStatus">
          <el-radio-button label="1"
            >已选（{{ chooseGoods.length }}）</el-radio-button
          >
          <el-radio-button label="0">未选</el-radio-button>
        </el-radio-group>
      </el-form-item>
      <el-button
        size="small"
        type="success"
        @click="onQuery()"
        v-show="selectStatus == '0'"
        >检索</el-button
      >
      <el-button
        size="small"
        type="info"
        @click="onReset()"
        v-show="selectStatus == '0'"
        >重置</el-button
      >
      <el-button size="small" type="primary" @click="onSubmit()"
        >确定</el-button
      >
    </el-form>
    <div>
      <draggable
        v-model="chooseGoods"
        @end="onDragEnd"
        class="contentContinner"
        v-if="selectStatus == '1'"
      >
        <clinicsCategoryGoodsItem
          v-for="(item, index) in chooseGoods"
          :key="index"
          :passedItem="item"
          @checkedGoodItem="chooseItem"
          :chooseGoods="chooseGoods"
        />
      </draggable>
      <div v-else class="contentContinner">
        <clinicsCategoryGoodsItem
          v-for="(item, index) in goodsData"
          :key="index"
          :passedItem="item"
          @checkedGoodItem="chooseItem"
          :chooseGoods="chooseGoods"
        />
      </div>
      <el-empty
        v-if="!showGoodsList().length"
        style="height: 100%; width: 100%; margin-top: -300px"
        description="暂无数据"
      />
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="searchFrom.current"
        layout="total,prev, pager, next, jumper"
        :total="searchFrom.total"
        style="text-align: end"
        v-if="selectStatus == '0'"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { queryGoodsClassList } from "@/api/productManage/goodsManger";
import clinicsCategoryGoodsItem from "./clinicsCategoryGoodsItem";
import { goodsClinicEssentialGoodsConfigsGetGoodsByConfigId } from "@/api/recommendationHome";
import { goodsPage } from "@/api/commodityList";
import draggable from "vuedraggable";
import Pagination from "@/components/Pagination";

export default {
  props: {},
  components: { clinicsCategoryGoodsItem, draggable, Pagination },
  data() {
    return {
      searchFrom: {
        goodsOneClassId: "",
        goodsTwoClassId: "",
        goodsThreeClassId: "",
        goodsName: "",
        factory: "",
        current: 1,
        size: 10,
        total: 0,
      },
      classListOne: [],
      classListTwo: [],
      classListThree: [],
      goodsData: [],
      selectStatus: "0",
      //   已选数组
      chooseGoods: [],
      sortList: [], //排序数组
    };
  },
  computed: {},
  watch: {},
  methods: {
    // 获取已选商品
    getSelectGoods(configId) {
      let params = { configId: configId, current: 1, size: 200 };
      goodsClinicEssentialGoodsConfigsGetGoodsByConfigId(params).then((res) => {
        const { records = [], total = 0 } = res.data;
        this.chooseGoods = records;
        this.searchFrom.total = total;
        this.selectStatus = "1";
      });
    },
    onDragEnd() {},
    // 展示数据
    showGoodsList() {
      if (this.selectStatus == "1") {
        return this.chooseGoods;
      } else {
        return this.goodsData;
      }
    },
    // 清空数据
    clearData() {
      this.searchFrom = {
        goodsOneClassId: "",
        goodsTwoClassId: "",
        goodsThreeClassId: "",
        goodsName: "",
        factory: "",
        current: 1,
        size: 10,
        total: 0,
      };
      this.classListOne = [];
      this.classListTwo = [];
      this.classListThree = [];
      this.goodsData = [];
    },
    getClassify1() {
      this.classListOne = [];
      queryGoodsClassList().then((res) => {
        if (res.code == 0 && res.data) {
          this.getClassifyTwo(res.data[0].id);
          this.classListOne = res.data;
        } else {
        }
      });
      this.onQuery();
    },
    getClassifyTwo(id) {
      this.classListTwo = [];
      queryGoodsClassList({ currentId: id, levelParam: 2 }).then((res) => {
        if (res.code == 0 && res.data) {
          this.getClassifyThree(res.data[0].id);
          this.classListTwo = res.data;
        } else {
          this.tableData = [];
        }
      });
    },
    getClassifyThree(id) {
      this.classListThree = [];
      queryGoodsClassList({ currentId: id, levelParam: 3 }).then((res) => {
        if (res.code == 0 && res.data) {
          this.classListThree = res.data;
        } else {
          this.tableData = [];
        }
      });
    },

    getGoodsList() {
      let params = {
        ...this.searchFrom,
        status: "ON_SALE",
        businessTypeFlag: 1,
      };
      goodsPage(params).then((res) => {
        if (res.code == 0) {
          const { records, total } = res.data.page;
          this.goodsData = records;
          this.searchFrom.total = total;
        }
      });
    },
    searchHandleOne(e) {
      this.searchFrom.goodsTwoClassId = "";
      this.searchFrom.goodsThreeClassId = "";
      this.getClassifyTwo(e);
    },
    searchHandleTwo(e) {
      this.searchFrom.goodsThreeClassId = "";
      this.getClassifyThree(e);
    },
    onQuery() {
      this.searchFrom.current = 1;
      this.getGoodsList();
    },
    onReset() {
      this.searchFrom.goodsOneClassId = "";
      this.searchFrom.goodsTwoClassId = "";
      this.searchFrom.goodsThreeClassId = "";
      this.searchFrom.goodsName = "";
      this.searchFrom.factory = "";
      this.searchFrom.current = 1;
      this.searchFrom.total = 0;
      this.goodsData = [];
      this.getClassify1();
      this.onQuery();
    },
    onSubmit() {
      if (this.chooseGoods.length === 0) {
        this.$message.warning("请至少选择一个商品后再保存");
        return;
      }
      this.$emit("submit", this.chooseGoods);
    },
    chooseItem(e) {
      const index = this.chooseGoods.findIndex(
        (item) => item.skuId === e.skuId
      );
      if (index == -1 && e.isChcked) {
        this.chooseGoods.push(e);
      } else if (index != -1 && !e.isChcked) {
        this.chooseGoods.splice(index, 1);
      }
    },
    handleCurrentChange(val) {
      this.searchFrom.current = val;
      this.getGoodsList();
    },
  },
};
</script>
<style lang="scss" scoped>
.recommend-goods {
  .contentContinner {
    height: 560px;
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    overflow-y: auto;
  }
}
</style>
